export default "__VITE_ASSET__CCiszM8O__"